import { Component, Inject, OnInit } from '@angular/core';
import { RelatorioService } from '@app/services/relatorio.service';
//import { CompleterService } from 'ng2-completer';
import { Paginacao } from '@app/models/util/paginacao';
import { ParticipanteService } from '@app/services/participante.service';
import { CDSMask } from '@app/utils/cds-mask';
import { ToastrService } from 'ngx-toastr';
import { RelatorioFinanceiroProcesso } from '@app/models/relatorio-financeiro-processo';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'app-financeiro-processo-relatorio',
  templateUrl: 'financeiro-processo-relatorio.component.html',
})
export class FinanceiroProcessoRelatorioComponent implements OnInit {

  lst: RelatorioFinanceiroProcesso[] = [];
  lstClientePagar: RelatorioFinanceiroProcesso[] = [];
  lstClienteReceber: RelatorioFinanceiroProcesso[] = [];
  lstAdvogado: RelatorioFinanceiroProcesso[] = [];
  lstDespesas: RelatorioFinanceiroProcesso[] = [];
  lstSubstabelecido: RelatorioFinanceiroProcesso[] = [];

  lstErros: string[];
  paginacao: Paginacao = new Paginacao();
  processoId: number;
  cdsMask: CDSMask = new CDSMask();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private relatorioService: RelatorioService,
    @Inject(ToastrService) public toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
        this.obterTodos(1);
      });
  }

  obterTodos(pagina: number) {
    if (this.processoId === undefined || this.processoId === 0) {
      this.toastr.error('Processo não encontrado', 'Notificação!');
    } else {
      this.relatorioService.obterFinanceiroProcesso(this.processoId, pagina)
        .subscribe(
          (data) => {
            this.lst = data.Dados;
            this.paginacao.totalDeItens = data.Total;
            this.lstErros = [];
            this.lstAdvogado = this.lst.filter(x => x.Sobre === 'Advogado');
            this.lstSubstabelecido = this.lst.filter(x => x.Sobre === 'Substabelecido');
            this.lstDespesas = this.lst.filter(x => x.Sobre === 'Despesas');
            this.lstClienteReceber = this.lst.filter(x => x.Sobre === 'Processo');
            this.lstClientePagar = this.lst.filter(x => x.Sobre === 'Cliente');
          },
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
            }
          }
        );
    }
  }

  btnVoltar() {
    this.router.navigate(['/processos/processo', this.processoId, 'financeiro']);
  }

  // public pageChanged(event: any): void {
  //   this.obterTodos(event.page);
  // }

}

